import { REPORT_TYPES, GRAPH_DATATYPE, QUALITATIVE_REPORT_LEVELS } from "../../../constants/app-constant";
import { getRandomUniqueColor, getLineGraphFormat } from "./format-utils";
import {
    VERTICALS,
    GRAPH_TYPES,
    CONSTANTS,
    useDynamicEntityColors,
} from "../../../constants/app-constant";
import { publicationPrintGenreFilterList } from "../../NewsAndAnalysis/NewAnalysis/AnalysisGroup/filter-constant";

const { V_ONLINE, V_PRINT } = VERTICALS;
const { PIE, TABLE, BAR_STACKED_EQUAL_HEIGHT, LINE, BAR_VERTICAL } = GRAPH_TYPES;
const {
    REPORTS: { TYPES },
} = CONSTANTS;

const {
    ENTITY,
    KEYWORD,
    JOURNALIST,
    CITY,
    PUBLICATION,
} = QUALITATIVE_REPORT_LEVELS;


export const getZonesFromResponse = (d = []) => {
    const result = d;
    const zones = result && result[result.sequence[0]].returnData.zones.map((zone) => zone.zone);
    return zones;
}
export const getEntitiesFromResponse = (d = []) => {
    const result = d;
    const entities = result && result[result.sequence[0]].returnData.entities.map((ent) => ent.entity_name);
    return entities;
}

export const newFormatGeolocationData = (
    d = [],
    report_type,
    type,
    selectedInlineGraphType,
    selectedInlineSentiment,
    selectedInlineEntity,
    selectedInlineZone,
) => {

    const isEntityLevel = /entity/i.test(report_type);

    const isJournalistLevel = /journalist/i.test(report_type);

    const isKeywordLevel = /keyword/i.test(report_type);

    const isPublicationLevel = /publication/i.test(report_type);

    const isCityLevel = /city/i.test(report_type);

    const isNewEntityLevel = /newentity/i.test(report_type);

    const level =
        (isNewEntityLevel) ? 'NewEntity' :
            (isEntityLevel) ? ENTITY :
                (isJournalistLevel) ? JOURNALIST :
                    (isPublicationLevel) ? PUBLICATION :
                        (isCityLevel) ? CITY :
                            (isKeywordLevel) ? KEYWORD :
                                "No Level";

    const isTrend = /trend/i.test(report_type);

    const isTonality = /tonality/i.test(report_type);

    const isPrint = type === V_PRINT;

    const currentMeasure = (report_type) => {
        const measures = {
            NOA: "article_count",
            CCM: "ccmtotal",
            MAV: "mavtotal",
            Index: "indextotal",
            WC: "wordcounttotal",
            Reach: "reachtotal",
        };
        const noaRegex = /noa/i;
        const ccmRegex = /ccm/i;
        const mavRegex = /mav/i;
        const indexRegex = /index/i;
        const wordCountRegex = /wordCount/i;
        const reachRegex = /reach/i;
        if (noaRegex.test(report_type)) {
            return measures.NOA;
        } else if (ccmRegex.test(report_type)) {
            return measures.CCM;
        } else if (mavRegex.test(report_type)) {
            return measures.MAV;
        } else if (indexRegex.test(report_type)) {
            return measures.Index;
        } else if (wordCountRegex.test(report_type)) {
            return measures.WC;
        } else if (reachRegex.test(report_type)) {
            return measures.Reach;
        } else {
            console.log("No report name match found");
            return;
        }
    }
    const measure = currentMeasure(report_type);
    if (isTrend) {
        return newFormatDataByTrend(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlineZone.value,
            isPrint);
    }
    else if (isTonality) {
        return newFormatDataByTonality(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlineZone.value,
            selectedInlineSentiment.value,
            isPrint);
    }
    else {
        return newFormatDataBySOV(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlineZone.value,
            isPrint,
        );
    }
};

//{datasets: {label: "", backgroundColor: "", barThcikness: "", borderColor: ""/[], borderWidth: 1, data: [], 
//fill: false, lineTension: 0}}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}

const newFormatDataBySOV = (d = [], level, graphType, currentMeasure, entity, selectedZone, isPrint) => {
    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const zones = level === 'NewEntity' ? [] : dataObj && dataObj.zones.map((zone) => zone.zone);
    const entities = dataObj && dataObj.entities;
    const labels = entities.map((ent) => ent.entity_name);
    const datasets = [];
    const colors = getRandomUniqueColor(zones.length);
    if (level === 'NewEntity') {
        const editions = dataObj && dataObj.editions.map((edition) => edition.edition);
        const colors = getRandomUniqueColor(editions.length);
        editions && editions.forEach((editon, idx) => {
            const label = editon;
            const backgroundColor = colors[idx];
            const data = [];
            entities && entities.forEach(({ entity_name }) => {
                let currVal = 0;
                if (graphData[editon] &&
                    graphData[editon].hasOwnProperty(entity_name)) {
                    currVal = parseData(graphData[editon][entity_name][currentMeasure], true);
                }
                data.push(currVal);
            });
            datasets.push({ label, backgroundColor, data });
        });
        return { labels, datasets };
    }
    else if (level === ENTITY && level !== 'NewEntity') {
        if (isPrint) {
            zones && zones.forEach((zone, idx) => {
                const label = zone;
                const backgroundColor = colors[idx];
                const borderColor = backgroundColor;
                const statesInZone = graphData.hasOwnProperty(zone) && Object.keys(graphData[zone]);
                const data = [];
                entities && entities.forEach(({ entity_name }) => {
                    let currVal = 0;
                    statesInZone && statesInZone.forEach((state) => {
                        const citiesInState = Object.keys(graphData[zone][state]);
                        citiesInState && citiesInState.forEach((city) => {
                            if (graphData[zone][state][city].hasOwnProperty(entity_name)) {
                                currVal += parseData(graphData[zone][state][city][entity_name][currentMeasure], true);
                            }
                        });
                    });
                    data.push(currVal);
                });
                datasets.push({ label, backgroundColor, borderColor, data });
            });
        } else {
            const selectedStates = graphData.hasOwnProperty(selectedZone) && Object.keys(graphData[selectedZone]);
            let selectedCitiies = [];
            selectedStates && selectedStates.forEach((state) => {
                const citiesInState = Object.keys(graphData[selectedZone][state]);
                selectedCitiies = [...selectedCitiies, ...citiesInState];
            });
            const cityColors = getRandomUniqueColor(selectedCitiies.length);
            selectedCitiies && selectedCitiies.forEach((city, idx) => {
                const label = city;
                const backgroundColor = cityColors[idx];
                const data = [];
                selectedZone && entities && entities.forEach(({ entity_name }) => {
                    let currVal = 0;
                    graphData.hasOwnProperty(selectedZone) && selectedStates.forEach((state) => {
                        if (
                            graphData.hasOwnProperty(selectedZone) &&
                            graphData[selectedZone].hasOwnProperty(state) &&
                            graphData[selectedZone][state].hasOwnProperty(city) &&
                            graphData[selectedZone][state][city].hasOwnProperty(entity_name)
                        ) {
                            currVal = parseData(graphData[selectedZone][state][city][entity_name][currentMeasure], true);
                        }
                    })

                    data.push(currVal);
                });
                datasets.push({ label, backgroundColor, data });
            });
        }
    } else {
        let level1Keys = graphData && Object.keys(graphData);
        level1Keys = [...new Set(level1Keys.map(x => x))].slice(0, 10);
        const level2Colors = level1Keys && getRandomUniqueColor(level1Keys.length);
        if (isPrint) {
            zones && zones.forEach((zone, idx) => {
                const label = zone;
                const backgroundColor = colors[idx];
                const data = [];
                level1Keys && level1Keys.forEach((val) => {
                    const statesInZone = graphData[val].hasOwnProperty(zone) && Object.keys(graphData[val][zone]);
                    let currVal = 0;
                    statesInZone && statesInZone.forEach((state) => {
                        const citiesInState = Object.keys(graphData[val][zone][state]);
                        citiesInState && citiesInState.forEach((city) => {
                            if (graphData[val][zone][state][city].hasOwnProperty(entity)) {
                                currVal += parseData(graphData[val][zone][state][city][entity][currentMeasure], true);
                            }
                        });
                    });
                    data.push(currVal);
                });
                datasets.push({ label, backgroundColor, data });
            });
            return { labels: level1Keys, datasets };
        } else {
            const selectedCitiies = [];
            level1Keys && level1Keys.forEach((val) => {
                if (graphData[val].hasOwnProperty(selectedZone)) {
                    const statesInSelectedZone = Object.keys(graphData[val][selectedZone]);
                    statesInSelectedZone.forEach((state) => {
                        const citiesInState = Object.keys(graphData[val][selectedZone][state]);
                        citiesInState.forEach((city) => {
                            if (selectedCitiies.indexOf(city) === -1)
                                selectedCitiies.push(city);
                        });
                    });
                }
            });
            const cityColors = getRandomUniqueColor(selectedCitiies.length);
            selectedCitiies && selectedCitiies.forEach((city, idx) => {
                const label = city;
                const backgroundColor = cityColors[idx];
                const data = [];
                level1Keys && level1Keys.forEach((val) => {
                    const statesInZone = graphData[val].hasOwnProperty(selectedZone) && Object.keys(graphData[val][selectedZone]);
                    let currVal = 0;
                    statesInZone && statesInZone.forEach((state) => {
                        if (
                            graphData[val][selectedZone][state].hasOwnProperty(city) &&
                            graphData[val][selectedZone][state][city].hasOwnProperty(entity)
                        ) {
                            currVal += parseData(graphData[val][selectedZone][state][city][entity][currentMeasure], true);
                        }
                    });
                    data.push(currVal);
                });
                datasets.push({ label, backgroundColor, data });
            });
            return { labels: level1Keys, datasets };
        }
    }
    return { labels, datasets };
}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}
const newFormatDataByTonality = (
    d = [],
    level,
    graphType,
    currentMeasure,
    entity,
    selectedZone,
    sentiment,
    isPrint) => {

    if (graphType === PIE) {
        return { labels: [], datasets: [], hcPieChartData: [{}] };
    }

    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const zones = dataObj && dataObj.zones;
    const entities = dataObj && dataObj.entities;
    const tonalities = dataObj && dataObj.tonality;
    const colors = getRandomUniqueColor(tonalities.length);
    const datasets = [];
    const labels = entities && entities.map((ent) => ent.entity_name);

    if (level === ENTITY) {
        if (isPrint) {
            tonalities && tonalities.forEach((tone, idx) => {
                const label = tone;
                const backgroundColor = colors[idx];
                const data = [];
                entities && entities.forEach((ent) => {
                    const statesInSelectedZone = graphData && graphData[tone][selectedZone] && Object.keys(graphData[tone][selectedZone]);
                    let currVal = 0;
                    statesInSelectedZone && statesInSelectedZone.forEach((state) => {
                        const citiesInState = graphData && Object.keys(graphData[tone][selectedZone][state]);
                        citiesInState && citiesInState.forEach((city) => {
                            if (graphData[tone][selectedZone][state][city].hasOwnProperty(ent.entity_name)) {
                                currVal += parseData(
                                    graphData[tone][selectedZone][state][city][ent.entity_name][currentMeasure],
                                    true
                                );
                            }
                        });
                    });
                    data.push(currVal);
                });
                datasets.push({ label, backgroundColor, data });
            });
        } else {
            const selectedStates = graphData.hasOwnProperty(sentiment) && graphData[sentiment].hasOwnProperty(selectedZone) && Object.keys(graphData[sentiment][selectedZone]);
            let selectedCitiies = [];
            selectedStates && selectedStates.forEach((state) => {
                const citiesInState = Object.keys(graphData[sentiment][selectedZone][state]);
                selectedCitiies = [...selectedCitiies, ...citiesInState];
            });
            const cityColors = getRandomUniqueColor(selectedCitiies.length);
            selectedCitiies && selectedCitiies.forEach((city, idx) => {
                const label = city;
                const backgroundColor = cityColors[idx];
                const data = [];
                selectedZone && entities && entities.forEach(({ entity_name }) => {
                    let currVal = 0;
                    graphData.hasOwnProperty(sentiment) && graphData[sentiment].hasOwnProperty(selectedZone) && selectedStates.forEach((state) => {
                        if (
                            graphData[sentiment][selectedZone].hasOwnProperty(state) &&
                            graphData[sentiment][selectedZone][state].hasOwnProperty(city) &&
                            graphData[sentiment][selectedZone][state][city].hasOwnProperty(entity_name)
                        ) {
                            currVal = parseData(graphData[sentiment][selectedZone][state][city][entity_name][currentMeasure], true);
                        }
                    });

                    data.push(currVal);
                });
                datasets.push({ label, backgroundColor, data });
            });
        }
    } else {
        const level1Keys = Object.keys(graphData);
        const level2Keys = [];
        const newLabels = entities && entities.map((ent) => ent.entity_name);
        level1Keys && level1Keys.forEach((tone) => {
            const currLevel2Keys = Object.keys(graphData[tone]);
            currLevel2Keys.forEach((level2val) => {
                if (level2Keys.indexOf(level2val) === -1) {
                    level2Keys.push(level2val);
                }
            });
        });
        const level2Colors = level2Keys && getRandomUniqueColor(level2Keys.length);
        if (isPrint) {
            const legendSet = [];
            const legendSetLength = Math.ceil(level2Keys.length / 10);
            for (let x = 1, y = 0; x <= 1; x++) {
                const set = [];
                level2Keys && level2Keys.filter((v, i) => (i >= y && i < (x * 10))).forEach((val, idx) => {
                    const label = val;
                    const backgroundColor = level2Colors[idx];
                    const data = [];
                    entities && entities.forEach(({ entity_name }) => {
                        let currVal = 0;
                        if (
                            graphData.hasOwnProperty(sentiment) &&
                            graphData[sentiment].hasOwnProperty(label) &&
                            graphData[sentiment][label].hasOwnProperty(selectedZone)
                        ) {
                            const states = Object.keys(graphData[sentiment][label][selectedZone]);
                            states.forEach((state) => {
                                const citiesInState = Object.keys(graphData[sentiment][label][selectedZone][state]);
                                citiesInState && citiesInState.forEach((city) => {
                                    if (graphData[sentiment][label][selectedZone][state][city].hasOwnProperty(entity_name)) {
                                        currVal += parseData(graphData[sentiment][label][selectedZone][state][city][entity_name][currentMeasure], true);
                                    }
                                });
                            });
                        }
                        data.push(currVal);
                    });
                    set.push({ label, backgroundColor, data });
                });
                legendSet.push({ labels: newLabels, datasets: set });
                y = x * 10;
            }
            return legendSet;
        }

    }
    return { labels, datasets };

}

//{datasets: {label: "", backgroundColor: "", barThcikness: "", borderColor: ""/[], borderWidth: 1, data: [], fill: false, lineTension: 0}}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}

const newFormatDataByTrend = (d = [], level, graphType, currentMeasure, entity, selectedZone, isPrint) => {
    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const zones = dataObj && dataObj.zones;
    const entities = dataObj && dataObj.entities;
    const labels = entities.map((ent) => ent.entity_name);
    const datasets = [];
    const level1Keys = graphData && Object.keys(graphData).sort();
    const level2Keys = [];
    if (level === ENTITY) {
        if (isPrint) {
            const entityColors = getRandomUniqueColor(entities.length);
            entities && entities.forEach((ent, idx) => {
                const label = ent.entity_name;
                const backgroundColor = (useDynamicEntityColors) ? ent.color_code : entityColors[idx];
                const borderColor = backgroundColor;
                const data = [];
                level1Keys && level1Keys.forEach((date) => {
                    const statesInZone = graphData[date].hasOwnProperty(selectedZone) && Object.keys(graphData[date][selectedZone]);
                    let currVal = 0;
                    statesInZone && statesInZone.forEach((state) => {
                        const citiesInState = Object.keys(graphData[date][selectedZone][state]);
                        citiesInState && citiesInState.forEach((city) => {
                            if (graphData[date][selectedZone][state][city].hasOwnProperty(label)) {
                                currVal += parseData(graphData[date][selectedZone][state][city][label][currentMeasure], true);
                            }
                        });
                    });
                    data.push(currVal);
                });
                datasets.push({ label, backgroundColor, borderColor, data });
            });
        }
        else {
            const selectedCitiies = [];
            level1Keys && level1Keys.forEach((val) => {
                if (graphData[val].hasOwnProperty(selectedZone)) {
                    const statesInSelectedZone = Object.keys(graphData[val][selectedZone]);
                    statesInSelectedZone.forEach((state) => {
                        const citiesInState = Object.keys(graphData[val][selectedZone][state]);
                        citiesInState.forEach((city) => {
                            if (selectedCitiies.indexOf(city) === -1)
                                selectedCitiies.push(city);
                        });
                    });
                }
            });
            const cityColors = getRandomUniqueColor(selectedCitiies.length);
            selectedCitiies && selectedCitiies.forEach((city, idx) => {
                const label = city;
                const backgroundColor = cityColors[idx];
                const data = [];
                level1Keys && level1Keys.forEach((val) => {
                    const statesInZone = graphData[val].hasOwnProperty(selectedZone) && Object.keys(graphData[val][selectedZone]);
                    let currVal = 0;
                    statesInZone && statesInZone.forEach((state) => {
                        if (
                            graphData[val][selectedZone][state].hasOwnProperty(city) &&
                            graphData[val][selectedZone][state][city].hasOwnProperty(entity)
                        ) {
                            currVal += parseData(graphData[val][selectedZone][state][city][entity][currentMeasure], true);
                        }
                    });
                    data.push(currVal);
                });
                datasets.push({ label, backgroundColor, data });
            });
            return { labels: level1Keys, datasets };
        }
    } else {
        level1Keys && level1Keys.forEach((date) => {
            const currLevel2Keys = Object.keys(graphData[date]);
            currLevel2Keys.forEach((level2val) => {
                if (level2Keys.indexOf(level2val) === -1) {
                    level2Keys.push(level2val);
                }
            });
        });
        const level2Colors = level2Keys && getRandomUniqueColor(level2Keys.length);
        if (isPrint) {
            level2Keys && level2Keys.forEach((val, idx) => {
                const label = val;
                const backgroundColor = level2Colors[idx];
                const data = [];
                level1Keys && level1Keys.forEach((date) => {
                    let currVal = 0;
                    if (
                        graphData[date].hasOwnProperty(label) &&
                        graphData[date][label].hasOwnProperty(selectedZone)
                    ) {
                        const states = Object.keys(graphData[date][label][selectedZone]);
                        states.forEach((state) => {
                            const citiesInState = Object.keys(graphData[date][label][selectedZone][state]);
                            citiesInState && citiesInState.forEach((city) => {
                                if (graphData[date][label][selectedZone][state][city].hasOwnProperty(entity)) {
                                    currVal += parseData(graphData[date][label][selectedZone][state][city][entity][currentMeasure], true);
                                }
                            });
                        });
                    }
                    data.push(currVal);
                });
                datasets.push({ label, backgroundColor, data });
            });
        }
    }
    return { labels: level1Keys, datasets };
}

const parseData = (value, float = false) => {
    let return_value = (float) ? Math.round(parseFloat(value * 100, 10)) / 100 : parseInt(value, 10);
    if (Number.isNaN(return_value)) {
        let newevalue = value.replace(/,/g, '')
        newevalue = (float) ? Math.round(parseFloat(newevalue * 100, 10)) / 100 : parseInt(newevalue, 10)
        return newevalue;
    }
    return return_value;
}
